import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { TableDetailSplitLayout } from '../../ui/TableDetailSplitLayout';

const GATEWAY_LIST_MIN_WIDTH = 240;
const GATEWAY_LIST_MAX_WIDTH = 480;
const GATEWAY_LIST_DEFAULT_WIDTH = 280;

export interface EfemGatewaySplitLayoutProps {
  list: ReactNode;
  panel: ReactNode;
  /** On small screens, hide the list and show only the detail panel. */
  mobileShowPanel?: boolean;
}

/**
 * Resizable master–detail shell for EFEM setup: gateway list (left) + editor (right).
 * Uses {@link TableDetailSplitLayout} with a draggable vertical divider on lg+.
 */
export function EfemGatewaySplitLayout({
  list,
  panel,
  mobileShowPanel = false,
}: EfemGatewaySplitLayoutProps) {
  return (
    <TableDetailSplitLayout
      sx={{ flex: 1, minHeight: 0, gap: { xs: 0, lg: 0 } }}
      tableWidth={GATEWAY_LIST_DEFAULT_WIDTH}
      minTableWidth={GATEWAY_LIST_MIN_WIDTH}
      maxTableWidth={GATEWAY_LIST_MAX_WIDTH}
      resizable
      table={
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            width: '100%',
            height: '100%',
            display: { xs: mobileShowPanel ? 'none' : 'flex', lg: 'flex' },
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {list}
        </Box>
      }
      panel={
        <Box
          sx={{
            height: '100%',
            minHeight: 0,
            display: { xs: mobileShowPanel ? 'flex' : 'none', lg: 'flex' },
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {panel}
        </Box>
      }
    />
  );
}
